export enum Tab {
  Info = "info",
  Tenants = "tenants",
  Fee = "fee",
  Garage = "garage",
  Walls = "walls",
  Furniture = "furniture",
  Mail = "mail",
  Improvements = "improvements",
  History = "history",
}
